export enum StateFiles {
	'Pending'='Pending',
    'Sent'='Sent',
    'Fail'='Fail'
}